<mat-form-field id="date-picker"
                appearance="outline"
                class="tight-input w-100"
                [ngClass]="{ 'mat-form-field-invalid': isControlInvalid }"
                subscriptSizing="dynamic">
  <input [(ngModel)]="selectedDate"
         matInput
         [matDatepicker]="datePicker"
         (focus)="onTouched()"
         (dateChange)="handleDateChange()"
         [min]="datePickerConfig.minDate ?? ''"
         [max]="datePickerConfig.maxDate ?? ''"
         [disabled]="isDisabled"
         [readonly]="isInputDisabled"
         [placeholder]="placeholderText"
         (input)="handleInputChange($event)"
         [ngModelOptions]="{ standalone: true }" />
  <mat-datepicker [touchUi]="datePickerConfig.touchUI" #datePicker [disabled]="isDisabled"></mat-datepicker>
  <mat-datepicker-toggle matIconSuffix [for]="datePicker" [disabled]="isDisabled"></mat-datepicker-toggle>
</mat-form-field>
